import $ from 'jquery/src/jquery';

export default () => {
    const nodeSelectors = {
        card: '[js-cards="card"]',
        description: '[js-cards="description"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.card)) {
            return
        }

        initCards()
    }

    function initCards() {
        $(nodeSelectors.card).on('mouseover', function (e) {
            let cardDescription = $(this).find(nodeSelectors.description)
            cardDescription.slideDown(250)
        })

        $(nodeSelectors.card).on('mouseleave', function (e) {
            let cardDescription = $(this).find(nodeSelectors.description)
            cardDescription.slideUp(250)
        })
    }

    return Object.freeze({
        init,
    })
}